import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CalendarPicker } from '@pwc/appkit-react-datepicker';

import { FormikPropTypes } from '../propTypes';

const DatepickerFormik = ({
  formik,
  name,
  value: rawValue,
  label,
  ...additionalProps
}) => {
  const value = (
    rawValue
    && typeof rawValue === 'string'
  ) ? new Date(rawValue) : rawValue;

  const handleChange = useCallback(value => {
    formik.setFieldValue(name, value);
  }, [name, formik]);

  return (
    <div className="sdk-select-formik-group">
      {label ? <label className="a-form-label">{label}</label> : null}
      <CalendarPicker
        value={value}
        onChange={handleChange}
        label={label}
        {...additionalProps}
      />
    </div>
  );
};

DatepickerFormik.propTypes = {
  formik: FormikPropTypes,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }).isRequired,
};

export default DatepickerFormik;
